module.exports = __webpack_public_path__ + "static/img/Steven_May_desktop.b9d2d57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Steven_May_desktop.jpg
// module id = 9lKA
// module chunks = 0